/*
 * @Author: lyx
 * @Date: 2024-08-13 10:25:17
 * @LastEditors: lyx
 * @LastEditTime: 2024-08-13 11:14:04
 * @FilePath: /dbrank_b/src/routes/visualChart/P28/chart.js
 */

import { xAxisLabelColor, yAxisLabelColor } from "../visualConfig";
import getGap from '../getGap'
import { drop } from 'lodash';

function getChartsData(arr) {
  let leftData = []  // db数据list
  let rightData = [] // 总条数数据list
  // 遍历arr数组，除最后一个item对象的list外，其他的item对象的list都装入leftData数组
  // 最后一个item对象的list装入rightData数组
  for (let index = 0; index < arr.length; index++) {
    const subArray = arr[index];
    if (index === arr.length - 1) {
      rightData = subArray.list
    } else {
      leftData = leftData.concat(subArray.list)
    }
  }
  return [leftData, rightData]
}
export default ({ label, list = [], color = [] }) => {
  let singleArr = getChartsData(list)
  const realLeft = getGap(singleArr[0], { split: 5 })
  const realRight = getGap(singleArr[1], { split: 5 })
  const min = Math.ceil(realLeft.min * realRight.max / realLeft.max)
  return {
    color,
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    legend: {
      bottom: 10,
      icon: 'stack',
      itemWidth: 16,
      itemHeight: 10
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: 50,
      containLabel: true
    },

    xAxis: {
      type: 'category',
      data: drop(label, 1),
      boundaryGap: false,
      axisLabel: { ...xAxisLabelColor }
    },
    yAxis: [
      {
        type: 'value',
        name: '数字品牌价值（单位：{db|DB}）',
        nameTextStyle: {
          // fontSize: 16,
          // fontWeight: 'bold',
          color: '#000',
          rich: {
            db: {
              // fontSize: 16,
              fontStyle: 'italic'
            }
          },
        },
        position: 'left',
        zeroAxisIndex: 1,
        axisLabel: { ...yAxisLabelColor },
        axisLine: { show: false },
        axisTick: { show: false },
        minorTick: { show: false },
        splitLine: { show: false },
        scale: true, // 设置y轴从零开始
        min: realLeft.min,
        max: realLeft.max,
      },
      {
        type: 'value',
        name: '右Y轴',
        position: 'right',
        name: '内容总条数（单位：条）',
        nameTextStyle: {
          // fontSize: 16,
          // fontWeight: 'bold',
          color: '#000',
          rich: {
            db: {
              // fontSize: 16,
              fontStyle: 'italic'
            }
          },
        },
        zeroAxisIndex: 0,
        axisLabel: { ...yAxisLabelColor },
        axisLine: { show: false },
        axisTick: { show: false },
        minorTick: { show: false },
        splitLine: { show: false },
        scale: true, // 设置y轴从零开始
        min: min,
        max: realRight.max,
      }
    ],
    series: list.map((item, index) => {
      const isLine = index === list.length - 1;
      return {
        type: 'line',
        name: item.title,
        areaStyle: isLine ? null : {},
        data: item.list,
        yAxisIndex: isLine ? 1  : 0,
        symbol: "none",

      }
    })
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P28/chart.js